import JSEncrypt from 'jsencrypt/bin/jsencrypt.min'

// 密钥对生成 http://web.chacuo.net/netrsakeypair

const publicKey = 'MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBANwHnc+MlsyRO04e6/XX493gbPcfbI9I\n' +
'oj7bnE4zS8mq0bvOyG50Kn6jqR4qx0k4Pvvz9YJQMdtMCvlLalj7aoECAwEAAQ=='

const privateKey = 'MIIBVgIBADANBgkqhkiG9w0BAQEFAASCAUAwggE8AgEAAkEA3Aedz4yWzJE7Th7r\n' +
'9dfj3eBs9x9sj0iiPtucTjNLyarRu87IbnQqfqOpHirHSTg++/P1glAx20wK+Utq\n' +
'WPtqgQIDAQABAkEAzhLEFtMRmV6cMLp9PK+KVxAOfhUMU9YvPrfoWMVqQeDh0p70\n' +
'o6bMl3Jgu/drUWlIHpdtmcZapwfBse3xvafXEQIhAPaGYYacJfWpbgDzKhshaNgr\n' +
'akVEK5loluFC3g9EU3svAiEA5HyLAYO25BP1YHArZoi4DkdWzfvC+1J7moySNbZo\n' +
'SU8CIQDgcbpLBtEcl1Qas0iriMBexzAqvgT/15Q+pFVuCuQCawIhAKqGiPhIZWcz\n' +
'vh6LmNidkUCW3aI+E/eeR8HAyB5uVMbhAiAPjhhclj0bqn2PC31SMfXLY5jGnXVX\n' +
'VICYuY0rnGyfbg=='

// 加密
export function encrypt (txt) {
  const encryptor = new JSEncrypt()
  encryptor.setPublicKey(publicKey) // 设置公钥
  return encryptor.encrypt(txt) // 对数据进行加密
}

// 解密
export function decrypt (txt) {
  const encryptor = new JSEncrypt()
  encryptor.setPrivateKey(privateKey) // 设置私钥
  return encryptor.decrypt(txt) // 对数据进行解密
}

